import { Descriptions, Card } from "antd";
import React from "react";
import useQuery from "../../../../hooks/useQuery";
import { useNavigate } from "react-router-dom";
import Typography from "antd/es/typography/Typography";
import { UserContext } from "../../../../context/UserContext";
import { useContext } from "react";
import useIsNurseMobile from "./useIsNurseMobile";
import { useLandingVisibleItems } from "./useLandingVisibleItems";
import LandingShowMore from "./LandingShowMore";

const SummaryInvestigations = ({ data }) => {
  const params = useQuery();
  const navigate = useNavigate();
  const { userDetails } = useContext(UserContext);
  const isNurseMobile = useIsNurseMobile();
  const {
    visibleItems,
    hasMore,
    canShowLess,
    showMore,
    showLess,
  } = useLandingVisibleItems(data || []);

  const role = userDetails?.currRole?.toLowerCase()?.trim();

  const url = new URL(window.location.href);
  const patientType = url.searchParams.get("patient-type");
  const status = url.searchParams.get("status");

  const handleNavigate = () => {
    if (role?.includes("nurse")) {
      navigate(
        `/nurse/home?status=${status}&patient=${params?.patient}&type=investigations`
      );
    } else {
      navigate(
        `/doctor/home?patient-type=${patientType}&status=${status}&patient=${params?.patient}&type=investigations`
      );
    }
  };

  const listData = isNurseMobile ? visibleItems : data;

  return (
    <Card
      className={`landing-summary-card${
        isNurseMobile ? " landing-investigations-card" : ""
      }`}
      title={
        <Typography onClick={handleNavigate} style={{ cursor: "pointer" }}>
          Recent Investigations
        </Typography>
      }
      style={{ marginTop: "10px" }}
      styles={{ header: { borderBottom: "none" }, body: { paddingTop: "0px" } }}
    >
      {data?.length > 0 ? (
        <>
          <Descriptions bordered={false} className="landing-investigations-list">
            {listData?.map((invs) => (
              <Descriptions.Item span={2} key={invs?.id}>
                <Typography.Text style={{ fontSize: "14px" }}>
                  {invs?.name || invs?.investigation?.name}
                </Typography.Text>
              </Descriptions.Item>
            ))}
          </Descriptions>
          {isNurseMobile ? (
            <LandingShowMore
              hasMore={hasMore}
              canShowLess={canShowLess}
              onMore={showMore}
              onLess={showLess}
            />
          ) : null}
        </>
      ) : (
        <div className="landing-summary-empty">No investigations yet</div>
      )}
    </Card>
  );
};

export default SummaryInvestigations;
